"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  // MODAL ACTIONS
  DISMISS_MODAL: null,
  SHOW_COMPOSE_EDIT_INTERSTITIAL_MODAL: null,
  SHOW_ONBOARDING_MODAL: null,
  // USER SETTINGS ACTIONS
  FETCH_USER_SETTINGS_PENDING: null,
  FETCH_USER_SETTINGS_SUCCEEDED: null,
  FETCH_USER_SETTINGS_FAILED: null,
  // CONTENT GROUP ACTIONS
  FETCH_CONTENT_GROUPS_PENDING: null,
  FETCH_CONTENT_GROUPS_SUCCEEDED: null,
  FETCH_CONTENT_GROUPS_FAILED: null,
  // FAVORITE BLOG ACTIONS
  FETCH_FAVORITE_BLOG_PENDING: null,
  FETCH_FAVORITE_BLOG_SUCCEEDED: null,
  FETCH_FAVORITE_BLOG_FAILED: null
});

exports.default = _default;
module.exports = exports.default;